<template>
    <div class="body">
        <div class="col-12 pb-5 mb-4" v-if="pageloader">
            <img src="../../assets/pageloader.svg" class="pageloader" alt="pageloader">
        </div>
        <div v-if="!pageloader">
            <div class="card ml-3 mr-3 mt-lg-2">
                <div class="card-body">
                    <div class="pl-1 mb-2">
                        <span class="fontsize14 black stylebold proximanova">Job Details</span>
                    </div>
                    <div class="form">
                        <div class="row no-gutters">
                            <div class="col-12 col-md-6 col-lg-5">
                                <div class="col mt-2 pl-0">
                                <div class="input-group">
                                  <small class="required small-label" v-if="JobObject.isEditJobPage">Job Title</small>
                                    <input
                                        type="text"
                                        name="Job Title"
                                        data-vv-as="Job Title"
                                        class="input-create proximanova"
                                        v-model="JobObject.jobTitle"
                                        autocomplete="off"
                                        v-validate=" 'required' "
                                        data-vv-scope="jobDetails"
                                        required
                                        :disabled="JobObject.isEditJobPage"
                                    />
                                    <span class="bar"></span>
                                    <label class="label-create required proximanova" v-if="!JobObject.isEditJobPage">Job Title</label>
                                </div>
                                <div class="col d-flex ml-2">
                                    <div v-if="errors.has('jobDetails.Job Title')" class="alert-danger">{{ errors.first('jobDetails.Job Title') }}</div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="row no-gutters mt-3">
                            <div class="col d-flex justify-content-start align-items-center mt-2">
                                <div class="form-group col-12 pl-0 pr-0">
                                    <label for="companyBenefitsDescriptionTextarea" class="small-label required mb-2">Job Description</label>
                                     <!-- <textarea class="form-control proximanova" v-model="JobObject.jobDescription" id="companyBenefitsDescriptionTextarea"
                                        rows="3"
                                        cols="80"
                                        spellcheck="true"
                                        maxlength="2000"
                                        name="Job Description"
                                        data-vv-as="Job Description"
                                        v-validate=" 'required' "
                                        @keyup="validateJobDetails"
                                        data-vv-scope="jobDetails"
                                        required
                                    ></textarea> -->
                                    <div class="quillheight">
                                    <quill-editor v-model="JobObject.jobDescription" ref="myQuillEditor" class="quill1"></quill-editor>
                                    </div>
                                    <div class="col d-flex ml-2">
                                        <div v-if="errors.has('jobDetails.Job Description')" class="alert-danger">{{ errors.first('jobDetails.Job Description') }}</div>
                                        <div v-if="JobObject.jobDescription.length < 10" class="alert-danger mt-4">Job Description is required to post a job</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <label class="small-label required mb-2 mt-3">Add Skills</label>
                        <div class="row no-gutters">
                            <!-- <div class="col-12 col-md-6 col-lg-6">
                                <div class="d-flex input-group pl-0 col-12 mt-2 mb-2"  >
                                  <div class="input-group-prepend">
                                      <span class="input-group-append img-input-group" id="basic-text1">
                                        <img src="../../assets/Search.svg" width="20px" alt="search" class="imgborder1 " />
                                      </span>
                                  </div>
                                  <input class="form-control searchtext font14-opacity60 bigger-font "  type="text" placeholder="Search Skills" id="searchskill" autocomplete="off" aria-label="Search"/>     
                                </div>
                            </div> -->
                            <div class="col-12 col-md-6 col-lg-6">
                              <div class="d-flex input-group col-12 pl-sm-0 mt-2 mb-2"  >
                                <input class="form-control searchtext font14-opacity60 bigger-font" v-model="customSkill"  type="text" placeholder="Add Custom skills" id="customskill" autocomplete="off" aria-label="Search"/>
                                <div class="input-group-prepend">
                                      <span class="input-group-append1 img-input-group" id="basic-text1" @click="addCustomSkill">
                                        <span class="ml-4 pointer backgroundcolor5 prependadd borderradiushalf stylebold" title="add">+</span>
                                      </span>
                                  </div>
                              </div>
                            </div>
                        </div>
                        <div class="row no-gutters mt-3">
                          <div v-if="skillsList.length > 0" class="d-flex flex-wrap mb-3 col" >
                              <div v-for="(skill, index) in skillsList" :key="index" >
                                <div class="p-1 pl-2 pr-2 mr-3 border-0 black60 fontsize14 backgroundcolor2 stylebold borderradius10 proximanova d-flex mt-1">
                                    {{skill.skillName}}
                                    <span class="ml-4 pointer backgroundcolor5 borderradiushalf stylebold" title="add" @click="addExistingSkill(index)">+</span>
                                </div>
                              </div>
                          </div>
                        </div>
                        <div class="col pl-0 mb-3">
                          <span class="fontsize12 black proximanova stylebold ml-1">Skills Added</span>
                          <div class="row no-gutters mt-3">
                            <div v-if="JobObject.addedSkillsList.length > 0" class="d-flex flex-wrap mb-3 col" >
                                <div v-for="(skill, index) in JobObject.addedSkillsList" :key="index" >
                                  <div class="pl-2 pr-2 p-1 mr-3 black60 fontsize14 backgroundcolor2 stylebold borderradius10 proximanova d-flex mt-1">
                                      {{skill.skillName}}
                                      <span class="ml-4 pointer backgroundcolorwhite borderradiushalf stylebold" title="close" @click="removeSelectedSkill(index)">x</span>
                                  </div>
                                </div>
                            </div>
                          </div>
                          <span class="fontsize12 red proximanova stylebold ml-1" v-if="JobObject.addedSkillsList.length < 3">More than two skills are mandatory for a job</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card ml-3 mr-3 mb-4 p-4 mt-5">
                <div class="d-lg-flex d-md-flex justify-content-between">
                    <div class="d-flex flex-column">
                        <span class="fontsize12 black60 proximanova">By continuing, you agree with</span>
                        <span class="fontsize12 stylebold black60 proximanova">Worknotion <a :href="wndata.termsandConditions" target="_blank" rel="noopener noreferrer" class="proximanova blue pointer">Terms & Conditions</a></span>
                    </div>
                    <div class="d-flex justify-content-end btnsection">
                        <button class="btn fontsizemd borderradius20 navtoPage proximanova" :disabled="saveasDraftBtnClicked" @click="openCancelModal">Cancel</button>
                        <img src="../../assets/uploadvideo.svg" alt="uploading" width="32px" class="img-fluid ml-2 mr-3" v-if="saveasDraftBtnClicked">
                        <button class="btn button-cancel11 ml-2 borderradius20 mr-2 navtoPage proximanova" v-if="!saveasDraftBtnClicked" @click="saveAsaDraft">Draft</button>
                        <button class="btn sign-up-button fontsizemd borderradius20 proximanova blackbackhroundsignin" :disabled="saveasDraftBtnClicked" id="jobdetbtn" @click="moveToMoreDetailsSecttion">Continue</button>
                    </div>
                </div>
            </div>
            <cancel-modal v-if="showcancelModal" :JobObject="JobObject" @closeCancelModal="closeCancelModal"></cancel-modal>
            <APIErrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIErrorModal>
        </div>
    </div>
</template>
<script>
import { bus } from "@/main.js";
import cancelModal from './cancelModal.vue'
import httpjob from "@/js/http-postjob.js"
import router from '../../router.js'
import APIErrorModal from '../../components/APIerrorpopup.vue'
import wndata from '@/js/wn_data.json'
export default {
    data() {
        return{
            pageloader: false,
            skillsList : [{ skillName :'java' }, { skillName :'html'}, { skillName :'css'}, { skillName :'javascript'}],
            //job details section
            customSkill : '',
            jobDetjobTitle : '',
            jobDescription : '',
            // addedSkillsList : [],
            //cancel modal
            showcancelModal : false,
            jobDetailsDisable : true,
            saveasDraftBtnClicked : false,
            displayAPIerrorModal : false,
            //json
            wndata : {},
        }
    },
    props : [
        'JobObject'
    ],
    components : {
        cancelModal,
        APIErrorModal
    },
    mounted() {
        console.log("job object : ", this.JobObject)
        this.wndata = wndata;
        // this.addedSkillsList  = this.JobObject.addedSkillsList;
        window.scrollTo(0, 0)
    },
    methods : {
      closeAPIerrorModal(){
        this.displayAPIerrorModal = false;
      },
      openCancelModal() {
        this.$validator.validateAll("jobDetails").then((isValid) => {
          if(isValid && this.JobObject.addedSkillsList.length > 2){
        this.showcancelModal = true;
          }
        })
      },
      closeCancelModal(statusObj) {
        console.log(statusObj)
        this.showcancelModal = false;
      },
      validateJobDetails(){
        this.$validator.validateAll("jobDetails").then((isValid) => {
          if(isValid && this.JobObject.addedSkillsList.length > 2){
            this.jobDetailsDisable = false;
            console.log("valid")
            document.getElementById("jobdetbtn").classList.add("blackbackhroundsignin");
          } else{
            this.jobDetailsDisable = true;
            console.log("not valid")
            document.getElementById("jobdetbtn").classList.remove("blackbackhroundsignin");
          }
        })
      },
      saveAsaDraft() {
        var vm = this;
        this.$validator.validateAll("jobDetails").then((isValid) => {
          if(isValid && this.JobObject.addedSkillsList.length > 2){
        this.saveasDraftBtnClicked = true;
        let finalObj = {
          jobId : this.JobObject.jobId,
          companyProfileId : this.JobObject.companyProfileId,
          employeeId : this.JobObject.employeeId,
          employmentTypeId : this.JobObject.selectedEmploymentType,
          titleId : this.JobObject.titleId,
          jobTitle : this.JobObject.jobTitle,
          jobDesc : this.JobObject.jobDescription,
          seniorityId : this.JobObject.selecetdSeniority,
          jobStatus : 'DRAFT',
          payScaleFrom : this.JobObject.selectedPayScaleFrom,
          payScaleTo : this.JobObject.selectedPayScaleTo,
          countryId : this.JobObject.country,
          stateId : this.JobObject.state,
          cityId : this.JobObject.city,
          zipcode : this.JobObject.pinCode,
          companyBenefitsList : this.JobObject.companyBenefitsList,
          addedSkillsList : this.JobObject.addedSkillsList,
          communicationType : this.JobObject.communicationType,
          emailId : this.JobObject.emailId,
          jobActive : 'ACTIVE',
          screeningQuestionsList : this.JobObject.screeningQuestionsList,
          jobPostedBy : this.JobObject.jobPostedBy
        }
        console.log("final job object for draft: ", finalObj)
        httpjob.post('/postjob/PostingUserInfo', finalObj)
          .then((response) => {
              console.log(response)
              this.saveasDraftBtnClicked = false;
              vm.$toast.success("successfully saved as draft")
              router.push({
                name : 'draftJobs'
              })
          }).catch((e) => {
              console.log(e.response)
              this.saveasDraftBtnClicked = false;
              this.displayAPIerrorModal = true;
          })
          }
        })
      },
      moveToMoreDetailsSecttion : function() {
        // this.JobObject.addedSkillsList = this.addedSkillsList;
        this.$validator.validateAll("jobDetails").then((isValid) => {
          if(isValid && this.JobObject.addedSkillsList.length > 2 && this.JobObject.jobDescription.length>0){
        this.JobObject.isJobDetailsCompleted = true;
        bus.$emit('moveToNext', 'moreDetails');
          }
        })
      },
      addExistingSkill(ind) {
        let skillObj = {
          jobSkillId: null,
          skillName: this.skillsList[ind].skillName,
          creationUserI: this.JobObject.emailId,
          updatedUserI: this.JobObject.emailId       
        }
        this.JobObject.addedSkillsList.push(skillObj)
        this.skillsList.splice(ind,1)
        console.log(this.JobObject)
        //this.validateJobDetails()
      },
      addCustomSkill() {
        let skillObj = {
          jobSkillId: null,
          skillName: this.customSkill,
          creationUserI: this.JobObject.emailId         
        }
        if(this.customSkill.length > 0) {
          this.JobObject.addedSkillsList.push(skillObj);
          this.customSkill = ''
          console.log(this.JobObject)
        }
        //this.validateJobDetails()
      },
      removeSelectedSkill(index){
        this.JobObject.addedSkillsList.splice(index, 1)
        console.log(this.JobObject)
        //this.validateJobDetails()
      }
    }
}
</script>
<style scoped>
@import '../../css/vue-multiselect.min.css';
@import '../../css/vue2-datepicker.css';
.nav-link {
  padding: 0px 0px 0px 0px;
}
.nav-tabs {
  border-bottom: none !important;
}
.quill1{
  width: 100%;
}
.card-header {
  padding: 0px 0px 3px 0px;
  margin-bottom: 0;
  border: 1px solid #d9dce1;
  opacity: 0.6;
  border-radius: 8px;
  background-color: #f0f2f5;
}
.card-header {
  border-radius: 8px !important;
}
.profile-pic {
	position: relative;
	display: inline-block;
}
.profile-border{
  padding: 2px;
  border: 2px solid #ced4da;
  border-radius: 50%;
}
.edit {
  cursor: pointer;
  border: 1px solid rgba(31, 31, 31, .1);
  border-radius: 50%;
	position: absolute;
	right: 0;
	top: 0;
  margin-top:70%
}
.mouseoveraction:hover{
	background-color: rgba(161, 166, 179,.2);
  border-radius: 8px;
}
.border-tab {
  border-bottom-style: solid;
  border-bottom-color: #0078ff;
}
.list-text-color {
  color: #0078FF ;
  font-family: "Proxima Nova";
  font-weight: bold;
  letter-spacing: 0;
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
nav ul li a {
  padding: 0.5rem 0.9rem;
}
.nameblock {
  padding-left: 0 !important;
}
.input-create {
  font-size: 18px;
  padding: 10px 10px 10px 5px;
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #757575;
}
.input-create:focus{
/* .input-create:valid { */
  outline: none;
  border-bottom: 1px solid #0078FF;
}
.multiselectInput-create {
  font-size: 18px;
  padding: 0 0 0 0;
  display: block;
  width: 100%;
  border: none;
  /* border-bottom: 1px solid #757575; */
}
.multiselectInput-create:hover {
  border-bottom: 1px solid #0078FF !important;
}
.form-control:focus{
    outline: none !important;
    box-shadow: none !important; 
}
.input-group-append{
  background-color: rgba(161, 166, 179,0.1);
  padding: 2px 10px;
  border-radius: 10px 0 0 10px;
}
.input-group-append1{
  background-color: rgba(161, 166, 179,0.1);
  padding: 6px 10px;
  border-radius: 0 10px 10px 0;
}
.prependadd{
  padding: 0 7px 3px 7px !important;
  margin : auto;
}
.searchtext{
    border-radius: 10px;
    background-color: rgba(161, 166, 179,0.2);
    border: #DDDFE5;  
}
.searchtext:focus{
  background-color: rgba(161, 166, 179,0.2);
}
.backgroundcolor5{
  padding: 0 7px;
}

.backgroundcolorwhite{
  padding: 0 7px;
}
/* LABEL ======================================= */
.label-create {
  color: #999;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 20px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

/* active state */
.input-create:focus ~ .label-create,
.input-create:valid ~ .label-create {
  top: -15px;
  font-size: 14px;
  /* color: #0078FF; */
}
.button-cancel11 {
  border: 1px solid #1f1f1f;
  border-radius: 4px;
  transition : ease-out 0.3s;
  font-size: 14px !important;
	position: relative;
	z-index : 1;
}
@media only screen and (max-width: 600px) {
  .pageloader {
    width: 20%;
    margin-top: 25%;
    margin-left: 40%;
  }
  .btnsection{
      margin-top: 10px !important;
  }
}
@media screen and (min-width: 800px) {
  .quillheight{
  height: 250px !important;
}
.quill1{
  width: 100%;
  height: 200px;
}
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}
</style>
